
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empresas",
      function () {
        return require("private-next-pages/empresas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/empresas"])
      });
    }
  